var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"multi-line":true,"timeout":_vm.timeout},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n  "),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.snackbar = false}}},[_vm._v("\n    Close\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }